import userActions from './store/modules/user'

export const DEFAULT_PROJECT_SETTINGS = {
  red: 30,
  amber: 50,
  green: 70,
}

export const USER_MENU = [{
  title: 'Home',
  link: 'home',
}, {
  title: 'Help',
  link: 'help',
}, {
  title: 'Logout',
  handler: (dispatch, getState) => {
    dispatch(userActions.logout())
  }
}]

export const GUEST_MENU = [{
  title: 'Login',
  link: 'login',
}, {
  title: 'Help',
  link: 'help',
}]

const settings = {
  USER_MENU,
  GUEST_MENU,
  DEFAULT_PROJECT_SETTINGS,
}

export default settings